export const LOGO_VIEW_BOX = '-66 -22 300 300';

export const LOGO_PATHS = [
  'M9.46022 182.783L165.444 124.31C167.801 123.413 168.746 120.559 167.344 118.44L89.5951 1.7494C87.8759 -0.825887 84.0043 -0.488689 82.7347 2.30553L4.49805 177.47C3.0617 180.65 6.17857 184.002 9.46022 182.783Z',
  'M7.51827 195.621L117.454 156.801C120.31 155.795 123.197 158.167 122.791 161.17L114.073 228.48C113.773 230.927 111.349 232.516 108.977 231.868L7.75731 203.378C3.9589 202.324 3.77683 196.95 7.4786 195.628L7.51827 195.621Z',
  'M15.7592 255.415C24.533 255.415 31.5185 248.266 31.5185 239.656C31.5185 231.207 24.533 224.059 15.7592 224.059C6.82372 224.059 0 231.207 0 239.656C0 248.266 6.82372 255.415 15.7592 255.415Z',
] as const;

export const POINT_COUNT = 120;

export const CURVE_STEPS = 32;

export const CENTER_X = 84;

export const CENTER_Y = 128;

export const ORBIT_RADIUS = 90;

export const ORBIT_DOTS = [
  { angle: -90, radius: 34 },
  { angle: 30, radius: 25 },
  { angle: 150, radius: 17 },
] as const;

export const PATTERN_INTRO_DURATION = 2.1;

export const PATTERN_STEP_DURATION = 1.2;

export const DEFAULT_LOGO_LOADING_SPEED = 1.2;
